import { BaseOption } from 'ui/selectv2/types';

export const convertValuesToOptions = (values: string[]): BaseOption<string>[] =>
  values.map((value) => ({
    id: value,
    value,
    label: value,
  }));
